import type { GridElementsDetailsByCalculationType } from '../../derived-state/gridElementsDetailsByCalculationType/GridElementsDetails';
import type { GridElementPropertyAttentionStatusByCalculationType } from '../AttentionStatusRepository';
import {
  type AttentionStatuses,
  AttentionStatusProvider2
} from '../AttentionStatusRepository';

export function anyShortCircuitElementRequiresAttention(
  attentionStatuses: AttentionStatuses[]
) {
  const statusProvider =
    AttentionStatusProvider2.createFromState(attentionStatuses);
  const elementsRequiringAttention = statusProvider.getAllAttentionRequired();
  return elementsRequiringAttention.length > 0;
}

export function getShortCircuitDetailsGridElementsRequiringAttention(
  evaluatedElements: GridElementsDetailsByCalculationType,
  attentionStatuses: AttentionStatuses[]
) {
  const elementsRequiringAttention =
    getElementsRequringAttentionIds(attentionStatuses);

  return evaluatedElements.shortCircuit.filter(f =>
    elementsRequiringAttention.find(e => e === f.id)
  );
}

export function getShortCircuitIssuesGridElementsIdsRequringAttention(
  statusesByType: GridElementPropertyAttentionStatusByCalculationType
) {
  const statusProvider = AttentionStatusProvider2.createFromState(
    statusesByType.shortCircuit
  );

  const elementsRequiringAttention =
    getElementsRequiringAttentionIds(statusProvider);

  return elementsRequiringAttention;
}

export function countShortCircuitGridElementsRequiringAttention(
  statusesByType: GridElementPropertyAttentionStatusByCalculationType
): number {
  const gridElementsRequiringAttentionInShortCircuitCalculation =
    getShortCircuitIssuesGridElementsIdsRequringAttention(statusesByType);

  const uniqueElementsCount = new Set([
    ...gridElementsRequiringAttentionInShortCircuitCalculation
  ]).size;
  return uniqueElementsCount;
}

export function countShortCircuitIssuesRequiringAttention(
  statusesByType: GridElementPropertyAttentionStatusByCalculationType
): number {
  const gridElementsRequiringAttentionInShortCircuitCalculation =
    getShortCircuitIssuesGridElementsIdsRequringAttention(statusesByType);

  return gridElementsRequiringAttentionInShortCircuitCalculation.length;
}

function getElementsRequringAttentionIds(
  attentionStatuses: AttentionStatuses[]
) {
  const statusProvider =
    AttentionStatusProvider2.createFromState(attentionStatuses);

  const elementsRequiringAttention =
    getElementsRequiringAttentionIds(statusProvider);
  return elementsRequiringAttention;
}

function getElementsRequiringAttentionIds(
  statusProvider: AttentionStatusProvider2
) {
  return statusProvider.getAllAttentionRequired().map(m => m.gridElementId);
}
